
<div class="upload-container p-3">
  <h3 class="text-lg font-semibold mb-3">Upload Image</h3>

  <!-- Preview if image exists -->
  <div *ngIf="previewUrl; else uploadBox" class="preview-box">
    <img [src]="previewUrl" alt="Uploaded Image" />
    <div class="overlay mt-2 d-flex gap-2 justify-content-center">
      <button mat-stroked-button color="warn" (click)="removeImage()" [disabled]="imgLoader">
        Remove
      </button>
      <button mat-raised-button style="color:var(--primary-bg-color)"  (click)="fileInput.click()" [disabled]="imgLoader">
        Change
      </button>
    </div>
  </div>

  <!-- Upload box (when no preview) -->
  <ng-template #uploadBox>
    <div class="upload-box"
         (click)="fileInput.click()">
      <mat-icon>upload</mat-icon>
      <p>
        <span class="click-text">Click to upload</span> or drag and drop
      </p>
    </div>
  </ng-template>

  <!-- Hidden File Input -->
  <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" hidden />

  <!-- Loader -->
  <div *ngIf="imgLoader" class="mt-3 text-center">
    <!-- <mat-spinner diameter="40"></mat-spinner> -->
    <p class="text-muted mt-2">Uploading...</p>
  </div>

  <!-- Actions -->
  <div class="mt-4 d-flex justify-content-end gap-2">
    <button mat-button (click)="close()" [disabled]="imgLoader">Cancel</button>
    <button mat-raised-button style="color:#fff;background-color:var(--primary-bg-color)" 
            (click)="uploadImage()"
            [disabled]="!selectedFile || imgLoader">
      {{ imgLoader ? 'Uploading...' : 'Upload' }}
    </button>
  </div>
</div>
